import {  
  ApiReduxAction,
  IAppleWalletPassStatusResponseC,
  IAppleWalletProvisionC,
  IExposeRedux,
} from '@unikey/unikey-commons/release/comm'

import {
  identityApi,
  api,
} from '../../internal'

export enum userActions {
  TOGGLE_CHANGE_PASSWORD_WORKFLOW = 'TOGGLE_CHANGE_PASSWORD_WORKFLOW',
  TOGGLE_ADD_PASSWORD_WORKFLOW = 'TOGGLE_ADD_PASSWORD_WORKFLOW',

  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',

  ADD_PASSWORD_EMAIL_REQUEST = 'ADD_PASSWORD_EMAIL_REQUEST',
  ADD_PASSWORD_EMAIL_SUCCESS = 'ADD_PASSWORD_EMAIL_SUCCESS',
  ADD_PASSWORD_EMAIL_FAILURE = 'ADD_PASSWORD_EMAIL_FAILURE',
  
  RESET_PASSWORD_DIRECT_REQUEST = 'RESET_PASSWORD_DIRECT_REQUEST',
  RESET_PASSWORD_DIRECT_SUCCESS = 'RESET_PASSWORD_DIRECT_SUCCESS',
  RESET_PASSWORD_DIRECT_FAILURE = 'RESET_PASSWORD_DIRECT_FAILURE',

  PROVISION_USER_APPLE_WALLET_PASSES_REQUEST = 'PROVISION_USER_APPLE_WALLET_PASSES_REQUEST',
  PROVISION_USER_APPLE_WALLET_PASSES_SUCCESS = 'PROVISION_USER_APPLE_WALLET_PASSES_SUCCESS',
  PROVISION_USER_APPLE_WALLET_PASSES_FAILURE = 'PROVISION_USER_APPLE_WALLET_PASSES_FAILURE',

  GET_APPLE_WALLET_PASS_INVITATION_STATUS_REQUEST = 'GET_APPLE_WALLET_PASS_INVITATION_STATUS_REQUEST',
  GET_APPLE_WALLET_PASS_INVITATION_STATUS_SUCCESS = 'GET_APPLE_WALLET_PASS_INVITATION_STATUS_SUCCESS',
  GET_APPLE_WALLET_PASS_INVITATION_STATUS_FAILURE = 'GET_APPLE_WALLET_PASS_INVITATION_STATUS_FAILURE',

}

export const toggleChangePasswordWorkflow = () => {
  return {
    type: userActions.TOGGLE_CHANGE_PASSWORD_WORKFLOW
  }
}

export const toggleAddPasswordWorkflow = () => {
  return {
    type: userActions.TOGGLE_ADD_PASSWORD_WORKFLOW
  }
}

const requestAddPasswordEmail = new ApiReduxAction(identityApi.acct, {
  request: { type: userActions.ADD_PASSWORD_EMAIL_REQUEST },
  success: {
    type: userActions.ADD_PASSWORD_EMAIL_SUCCESS,
    title: 'emailSent',
    message: 'checkEmailForInstructions',
    duration: 16000
  },
  failure: {
    type: userActions.ADD_PASSWORD_EMAIL_FAILURE,
    title: 'failedToSendEmail'
  }
}, (dux: IExposeRedux) => {
  return identityApi.acct.changePasswordIndirect.bind(identityApi.acct);
});
export const attemptRequestAddPasswordEmail = requestAddPasswordEmail.go;

export interface IChangePasswordActionParams {
  newPass: string,
  currPass: string
}
const resetPasswordDirect = new ApiReduxAction<IChangePasswordActionParams>(identityApi.acct, {
  request: { type: userActions.RESET_PASSWORD_DIRECT_REQUEST },
  success: {
    type: userActions.RESET_PASSWORD_DIRECT_SUCCESS,
    title: 'success',
    message: 'newPasswordSet'
  },
  failure: {
    type: userActions.RESET_PASSWORD_DIRECT_FAILURE,
    title: 'failedToUpdatePassword'
  }
}, (dux: IExposeRedux, { newPass, currPass }) => {
  return identityApi.acct.changePasswordDirect.bind(identityApi.acct, currPass, newPass);
});
export const attemptResetPasswordDirect = resetPasswordDirect.go;

export interface ICredentialInviteActionParams {
  inviteToken: string
}

const provisionAppleWalletCredentialPasses = new ApiReduxAction<ICredentialInviteActionParams, IAppleWalletProvisionC>(api, {
  request: { type: userActions.PROVISION_USER_APPLE_WALLET_PASSES_REQUEST },
  success: { type: userActions.PROVISION_USER_APPLE_WALLET_PASSES_SUCCESS },
  failure: {
    type: userActions.PROVISION_USER_APPLE_WALLET_PASSES_FAILURE,
    title: 'provisionAppleWalletPassesFailure'
  },
}, (dux: IExposeRedux, { inviteToken }) => {
  return api.cred.provisionAppleWallet.bind(api.cred, inviteToken);
});
export const attemptProvisionAppleWalletPasses = provisionAppleWalletCredentialPasses.go;


const checkAppleWalletInvitationPassStatus = new ApiReduxAction<ICredentialInviteActionParams, IAppleWalletPassStatusResponseC>(api, {
  request: { type: userActions.GET_APPLE_WALLET_PASS_INVITATION_STATUS_REQUEST },
  success: { type: userActions.GET_APPLE_WALLET_PASS_INVITATION_STATUS_SUCCESS },
  failure: {
    type: userActions.GET_APPLE_WALLET_PASS_INVITATION_STATUS_FAILURE,
    title: 'checkAppleWalletStatusFailure'
  },
}, (dux: IExposeRedux, { inviteToken }) => {
  return api.cred.getAppleWalletInvitationStatus.bind(api.cred, inviteToken);
});
export const attemptCheckAppleWalletInvitationPassStatus = checkAppleWalletInvitationPassStatus.go;

const checkSilentAppleWalletInvitationPassStatus = new ApiReduxAction<ICredentialInviteActionParams, IAppleWalletPassStatusResponseC>(api, {
  request: { type: 'silent' },
  success: { type: userActions.GET_APPLE_WALLET_PASS_INVITATION_STATUS_SUCCESS },
  failure: {
    type: userActions.GET_APPLE_WALLET_PASS_INVITATION_STATUS_FAILURE, 
    preventAlert: true
  },
}, (dux: IExposeRedux, { inviteToken }) => {
  return api.cred.getAppleWalletInvitationStatus.bind(api.cred, inviteToken);
});
export const attemptSilentCheckAppleWalletInvitationPassStatus = checkSilentAppleWalletInvitationPassStatus.go;
